<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader title="Investment Experience and Knowledge" :icon="UsersIcon"></WizardHeader>
            <ManagerListItem class="border-y border-gray-200 px-2 py-2" :manager="currentManager"></ManagerListItem>
            <div class="px-4 pb-6 sm:px-6">
                <LegalPersonTaxInformationForm v-model="taxRecidencies"></LegalPersonTaxInformationForm>
            </div>
            <div v-if="isBeneficialOwner()" class="px-4 sm:px-6">
                <BeneficialOwnerCompanyOwnershipForm v-model="companyOwnership"></BeneficialOwnerCompanyOwnershipForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="usePersonalAccountDataState().saving || !areTaxRecidenciesValid"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_manager_two_tax') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import {
    EsacComplianceProfile,
    TaxResidency,
    usePersonalAccountDataState,
} from '../../../../utilities/account/useAccountDataPersonal'
import { computed, inject, onMounted, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import ManagerListItem from '../../../account/legal/managers/ManagerListItem.vue'
import LegalPersonTaxInformationForm from './form/LegalPersonTaxInformationForm.vue'
import BeneficialOwnerCompanyOwnershipForm from './form/BeneficialOwnerCompanyOwnershipForm.vue'
import { putManager } from '../../../../utilities/api'
import { CompanyOwnership } from './form/forms'
import { currentNewManager } from './manager'

const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')

const companyOwnership = ref(new CompanyOwnership())

const taxRecidencies = ref([new TaxResidency()])

onMounted(() => {
    taxRecidencies.value = currentManager.value.tax_residencies
    if (currentManager.value.compliance_profiles?.esac?.company_ownership) {
        companyOwnership.value = currentManager.value.compliance_profiles.esac.company_ownership
    }
    if (taxRecidencies.value.length === 0) {
        taxRecidencies.value.push(new TaxResidency())
    }
})

const currentManager = computed(() => {
    return currentNewManager.value
})

const areTaxRecidenciesValid = computed(() => {
    return taxRecidencies.value.every((taxResidency) => {
        return taxResidency.country && (taxResidency.tin || taxResidency.no_tin_reason)
    })
})

async function submit() {
    let payload = currentManager.value
    if (Array.isArray(payload.compliance_profiles)) {
        payload.compliance_profiles = {}
    }
    payload.compliance_profiles.esac = Object.assign(new EsacComplianceProfile(), payload.compliance_profiles.esac)
    payload.compliance_profiles.esac.company_ownership = companyOwnership.value
    payload.tax_residencies = taxRecidencies.value
    await putManager(currentManager.value.natural_profile_uid, payload)
    navigateToNextTab()
}

function isBeneficialOwner() {
    return currentManager.value.is_beneficial_owner
}
</script>

<style scoped></style>
